namespace TabAurous.OMS {
    export interface ExchangeRateForm {
        ExchTypeId: Serenity.LookupEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        Narration: Serenity.TextAreaEditor;
    }

    export class ExchangeRateForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ExchangeRate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExchangeRateForm.init)  {
                ExchangeRateForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.DateEditor;
                var w3 = s.TextAreaEditor;

                Q.initFormType(ExchangeRateForm, [
                    'ExchTypeId', w0,
                    'CurrencyId', w0,
                    'ExchRate', w1,
                    'FromDate', w2,
                    'ToDate', w2,
                    'Narration', w3
                ]);
            }
        }
    }
}
